
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Prikvači',
	'find_label': 'Traži',
	'findCancelLabel': 'Opoziv',
	'sourcePaneLabel': 'Izabrani izvori',
	'sourcePaneContentLabel': 'Izaberite izvor',
	'addDataDashboardCoachMarkContents': 'Povucite i ispustite podatke iz panela podataka na kontrolnu ploču.',
	'addDataStoryCoachMarkContents': 'Povucite i ispustite podatke iz panela podataka u priču.',
	'addDataCoachMarkTitle': 'Dodaj podatke',
	'selectSourcesText': 'Izaberite i dodajte izvor podataka da izgradite svoju %{app}',
	'selectSourcesLabel': 'Izaberite izvor',
	'errorSourcesTitle': 'Neuspješno punjenje stabla podataka',
	'errorLoadingDataSources': 'Dogodila se greška tijekom učitavanja liste skupova podataka',
	'errorLoadingDataTree': 'Dogodila se greška tijekom učitavanja stabla.',
	'dataSetPaneLastUpdated': 'Zadnja promjena: %{date}',
	'dataSourcePaneDateUnknown': 'Nepoznato',
	'moreTitle': 'Više',
	'backLabel': 'Idi natrag',
	'addDataSourceDialogTitle': 'Dodavanje izvora podataka',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'dlg_use': 'Koristi',
	'dlg_RelinkDataSourceTitle': 'Zamijeni skup podataka \'%{dataSourceName}\' s ...',
	'propertiesDialogTitle': 'Svojstva',
	'missingDataSetData': 'Podaci ovog skupa podataka nisu dostupni. Osvježite skup podataka ili kontaktirajte svog administratora u vezi pristupa izvoru podataka.',
	'errorLoadingSource': 'Meta podaci za \'%{sourceName}\' se nisu učitali. Molim, kontaktirajte administratora za detalje.',
	'errorMessageTitle': 'Greška',
	'calculation_navigation_in_use': 'Brisanje izračuna ili staza navigacije poništava sve vizualizacije koje pozivaju izbrisane stavke. Jeste li sigurni da želite izbrisati?',
	'delete_confirm': 'Potvrda brisanja',
	'previewUnavailable': 'Pretinac podataka i globalni filteri nisu dostupni za ovaj tip paketa.',
	'contextualGridTabName': 'Podaci vizualizacije',
	'DATA_TRAY_no_data_text': '\'Vaši podaci će se pojaviti ovdje.\'',
	'contextualGridMenuLabel': 'Izbornik podataka vizualizacije',
	'contextualGridExport': 'Eksport',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Statistički detalji predviđanja',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Mjere točnosti',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Dijagnostika',
	'forecastDetailsForecastLabel': 'Predviđanje',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Točnost %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Sezonalnost',
	'forecastDetailsSeasonalPeriodLabel': 'Sezonski period',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Brojač koji nedostaje',
	'forecastDetailsSeriesLengthLabel': 'Duljina niza',
	'forecastDetailsIgnoredPeriods': 'Zanemareni periodi',
	'forecastDetailsTrendStrength': 'Snaga trenda',
	'forecastDetailsSeasonalityStrength': 'Snaga sezonalnosti',
	'forecastDetailsTimeDeltaUnit': 'Interval datuma/vremena',
	'forecastDetailsNotes': 'Napomene'
});
